export function getPsgDetails(state) {
    return state.passengers;
}
